import purchaseAgreementsNo from '../resources/no/purchase-agreements.json';
import purchaseAgreementsSe from '../resources/se/purchase-agreements.json';
import { PurchaseAgreementsLanguageResources } from '../types/PurchaseAgreementsResources';

export const purchaseAgreementsI18nResources: PurchaseAgreementsLanguageResources = {
  no: { purchaseAgreements: purchaseAgreementsNo },
  se: { purchaseAgreements: purchaseAgreementsSe },
};
